import { useRecoilState, useRecoilValue } from 'recoil'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import allCheckpointsAtom from '../allCheckpoints.atom'
import checkpointsSelectors from '../checkpoints.selectors'
import projectCheckpointsApi from '../projectCheckpoints.api'
import { IProjectCheckpoint } from '../projectCheckpoints.types'
import { useEffect } from 'react'

export const useAllCheckpointsState = () => {
  const [state, setState] = useRecoilState(allCheckpointsAtom)
  const map = useRecoilValue(checkpointsSelectors.checkpointsMap)

  const { wait, loading } = useHttpLoader()

  useEffect(() => {
    if (!state.items.length) {
      wait(projectCheckpointsApi.getAll(), (resp) => {
        if (resp.status === 'success') {
          setState(() => ({
            items: resp.body,
          }))
        }
      })
    }
  }, [])

  const addItem = (item: IProjectCheckpoint) => {
    setState((prev) => ({ ...prev, items: [item, ...prev.items] }))
  }

  return { checkpointsState: state, checkpointsMap: map, loading, addItem }
}
